import { useEffect } from "react";
import { Modal } from 'antd';

const BrowserDetectionModal = () => {
    
  useEffect(() => {

    Modal.warning({
        title: 'Please Wait!',
        content: (<p>This website works better in Google Chrome.<br></br>For a better experience, switch to Google Chrome</p>),
        okText: 'Switch To Google Chrome',
        onOk: handleButtonClick,
    });

  }, []);

  const handleButtonClick = () => {

    const mobileDetect = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)

    if (!navigator.userAgent === mobileDetect){
      window.location.href = 'https://www.google.com/chrome/';
      
    }else{

      if (navigator.userAgent.indexOf("Android") !== -1){
        window.location.href = 'https://play.google.com/store/apps/details?id=com.android.chrome';
      }
      if (navigator.userAgent.indexOf("like Mac")  || navigator.userAgent.indexOf("Mac") !== -1) {
        window.location.href = 'https://apps.apple.com/us/app/apple-store/id535886823';
      }
    }

  };

};

export default BrowserDetectionModal;
